// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Raleway', 'Raleway Fallback'","fontStyle":"normal"},"className":"__className_ea7542","variable":"__variable_ea7542"};